if ( $(window).width() < 767 ) {
	$(window).scroll(function() {
		if($("#default-button").length > 0)
		{
			var top_of_element = $("#default-button").offset().top;
			var bottom_of_element = $("#default-button").offset().top + $("#default-button").outerHeight();
			var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
			var top_of_screen = $(window).scrollTop();
	
			if ( top_of_screen < bottom_of_element){
					// the element is visible, do something
					$("body").removeClass('show-sticky');
					// $("#default-button").show();
					$("#sticky-buttons").css('display','none');
					
			} else {
					$("body").addClass('show-sticky');
					// $("#default-button").hide();
					$("#sticky-buttons").css('display','block');
			}
		}
	}); 
};
$(document).on('click', '#sticky-buttons a', function(){
	$('html, body').stop().animate({
			scrollTop: $('#default-button').offset().top - 350
	}, 600 );
});
$(document).on('click', '#review-link', function(){
	$('html, body').stop().animate({
			scrollTop: $('#looxReviews').offset().top - 20
	}, 600 );
});
$(document).on('click', '#faq-link', function(){
	$('html, body').stop().animate({
			scrollTop: $('#faq').offset().top - 20
	}, 600 );
});
$(document).on('click', 'body.christmas-page .promo-grid .promo-grid__content a', function(event){
  event.preventDefault();
	$('html, body').stop().animate({
			scrollTop: $('[data-section-type="product"]').offset().top - 20
	}, 600 );
});
$(document).ready(function() {

		var newViewportWidth = $(window).width();
		if (newViewportWidth < 768) {
			$(window).scroll(function() {
	
				if ($(this).scrollTop() > 1130) {
				  
				  $('.sticky__addTo-wrapp').fadeIn();
				} else {
				  
				  $('.sticky__addTo-wrapp').fadeOut();
				}
			  });
		}
});



// money-back-popup
$(document).on('click', '#money-back-btn', function() {
    $(".money-back-popup").fadeIn('slow');
    $("body").addClass('bg-overlay-popup');
    $(".bg-overlay").addClass('active');
});

function closePopup() {
    $(".money-back-popup").fadeOut('slow');
    $("body").removeClass('bg-overlay-popup');
    $(".bg-overlay").removeClass('active');
}

// Close the popup when clicking on specific elements
$(document).on('click', '.money-back-top, .bg-overlay', function() {
    closePopup();
});




// $(document).on("click", ".js-qty__adjust--minus", function() {
	
// 			fetch("?section_id=main-cart")
// 			  .then((res) => res.text())
// 			  .then((data) => {
// 				var cart__html = $(data);
// 				var render__html = $(".cart__checkout-wrapper", cart__html);
// 				$(".cart__checkout-wrapper").replaceWith(render__html);
		  
// 			  });
		  
		  
	  
// });




